import { Button, Form, InlineAlert, Modal } from '@design-systems/canvas-ui'

const hasRequiredValues = (fields, values) =>
  fields.every(
    ({ id, isRequired }) =>
      !isRequired || `${values[id] ?? ''}`.trim().length > 0,
  )

const ConfigurationModal = ({
  error,
  fields,
  isEditing = false,
  isOpen,
  isSaving,
  isSubmitDisabled = false,
  onChange,
  onClose,
  onSubmit,
  submitLabel,
  title,
  values,
}) => {
  const formId = 'configuration-form'
  const visibleFields = fields.filter(
    (field) => !(field.editOnly && !isEditing),
  )

  const footer = (
    <div className="configuration-modal__actions">
      <Button onClick={onClose} type="button" variant="secondary">
        Cancel
      </Button>
      <Button
        form={formId}
        isDisabled={
          !hasRequiredValues(visibleFields, values) || isSubmitDisabled
        }
        isLoading={isSaving}
        type="submit"
        variant="primary"
      >
        {submitLabel}
      </Button>
    </div>
  )

  return (
    <Modal
      className="configuration-modal"
      footer={footer}
      headingText={title}
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <Form id={formId} onSubmit={onSubmit}>
        <div className="configuration-modal__fields">
          {visibleFields.map((field) =>
            field.type === 'switch' ? (
              <Form.Field
                id={`configuration-${field.id}`}
                isChecked={Boolean(values[field.id])}
                key={field.id}
                label={field.label}
                onChange={(_event, { value }) =>
                  onChange({ [field.id]: value })
                }
                type="switch"
              />
            ) : (
              <Form.Field
                hintText={field.hintText}
                id={`configuration-${field.id}`}
                isDisabled={Boolean(isEditing && field.isDisabledOnEdit)}
                isRequired={field.isRequired}
                key={field.id}
                label={field.label}
                onChange={(event) =>
                  onChange({ [field.id]: event.target.value })
                }
                placeholder={field.placeholder}
                type={field.type}
                value={values[field.id] ?? ''}
              />
            ),
          )}
          {error && (
            <InlineAlert heading="Unable to save changes" variant="error">
              {error}
            </InlineAlert>
          )}
        </div>
      </Form>
    </Modal>
  )
}

export default ConfigurationModal
